import React from 'react'
import { DigitalResourcesTypeEnum } from 'modules/digital-product/enums/digital-resources-type-enum'
import { DigitalResourcesDataInterface, useDigitalResources } from '../hooks/use-digital-resources'
import { DigitalResourceEditType } from '../types/digital-resource-edit-interface'
import { BinIcon } from '@systemeio/ui/icons'

interface DigitalResourceWrapperProps {
  resource: DigitalResourceEditType
  children: (data: DigitalResourcesDataInterface) => JSX.Element
  onDelete?: () => void
}

const DigitalResourceWrapper = ({ resource, children, onDelete }: DigitalResourceWrapperProps) => {
  const courseId =
    resource.type === DigitalResourcesTypeEnum.membership_course ? resource.course : undefined

  const courseBundleId =
    resource.type === DigitalResourcesTypeEnum.membership_course_bundle
      ? resource.courseBundle
      : undefined

  const data = useDigitalResources({
    resourceType: resource.type,
    courseId,
    courseBundleId,
  })

  return (
    <>
      <div className="border-text-secondary/30 flex gap-3 rounded-lg border p-2 ">
        <div className={'flex flex-1 flex-col gap-3'}>{children(data)}</div>
        {onDelete && (
          <button onClick={onDelete} className={'group h-fit outline-hidden'}>
            <BinIcon className="h-[18px] w-[17px] cursor-pointer" />
          </button>
        )}
      </div>
    </>
  )
}

export default DigitalResourceWrapper
